import moment from "moment";

export class Common {

  static filterDate = (date: Date, showDates: any) => {
    const formatDay = moment(date).format("DD-MM-YYYY");
    var check = true;
    if (showDates.length) {
      check = showDates.indexOf(formatDay) !== -1
    }
    return check
  }

  static convertStringToDate = (value: string) => {
    let date = undefined;

    if (value !== "") {
      let values = value.split(":");
      date = moment().set({ 'hour': Number(values[0]), 'minute': Number(values[1]) });
    }
    return date
  }
}
